module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_moere_og_romsdal_pos.3a79cf73.svg";